import { SignedIn, SignedOut, SignInButton, SignUpButton, UserButton } from '@clerk/clerk-react';
import { Button, Group } from '@mantine/core';
import styled from 'styled-components';
import AvatarMenu from '../AvatarMenu';

type Props = {
  layout?: 'desktop' | 'mobile';
};
export default function LoginButtons({ layout = 'desktop' }: Props) {
  return (
    <>
      <SignedOut>
        <Group>
          <SignInButton mode="modal">
            <StyledSignInButton
              size="lg"
              variant={layout === 'mobile' ? 'filled' : 'outline'}
              color={layout === 'mobile' ? '#000' : 'transparent'}
              layout={layout}>
              SIGN IN
            </StyledSignInButton>
          </SignInButton>
          <SignUpButton mode="modal">
            <StyledSignUpButton
              size="lg"
              variant="filled"
              color={layout === 'mobile' ? '#fff' : '#000'}
              layout={layout}>
              SIGN UP
            </StyledSignUpButton>
          </SignUpButton>
        </Group>
      </SignedOut>
      <SignedIn>
        <AvatarMenu />
      </SignedIn>
    </>
  );
}

const StyledSignInButton = styled<any>(Button)`
  color: ${({ layout }) => (layout === 'mobile' ? '#fff' : '#000 ')} !important;

  text-align: center;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  /* padding: 1.9em 1.8em 1.6em; */
  font-family:
    URW Gothic,
    sans-serif;
  font-size: 0.75em !important;
  padding-top: 5px !important;
  font-weight: 700;
  line-height: 1.2em;
`;

const StyledSignUpButton = styled<any>(StyledSignInButton)`
  font-size: 0.75em !important;
  padding-top: 5px !important;
  color: ${({ layout }) => (layout === 'mobile' ? '#000' : '#f6f4ef ')} !important;
`;
